import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "content bg-white p-3 py-lg-4 px-lg-5" }
const _hoisted_4 = { class: "h4" }
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["responding-promotion", $options.classObject])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, [
            _renderSlot(_ctx.$slots, "promo_title", {}, () => [
              _createTextVNode(" Promo Title ")
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", null, [
                _renderSlot(_ctx.$slots, "promo_prompt", {}, () => [
                  _createTextVNode(" Promo Prompt ")
                ])
              ]),
              _withDirectives(_createElementVNode("input", {
                name: "ReferenceCode",
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enteredPromoCode) = $event)),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($options.handlePromoCode && $options.handlePromoCode(...args)), ["enter"]))
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelText, _ctx.enteredPromoCode]
              ]),
              (_ctx.showError)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    id: "invalidPromoCode",
                    class: "text-danger font-weight-bold pt-2",
                    innerHTML: _ctx.errorMessage
                  }, null, 8 /* PROPS */, _hoisted_7))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("input", {
                type: "submit",
                value: "Submit",
                class: "btn btn-secondary",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.handlePromoCode && $options.handlePromoCode(...args)))
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("button", {
        id: "showHidePromoBtn",
        class: "promo-btn position-absolute border-0 rounded-bottom pt-1 pb-2 py-lg-2 px-4",
        type: "button",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.toggleTab && $options.toggleTab(...args)))
      }, [
        _renderSlot(_ctx.$slots, "promo_tab_text", {}, () => [
          _createTextVNode(" Promo Tab Text ")
        ])
      ])
    ])
  ], 2 /* CLASS */))
}